import type { CreateContactLocationReq } from "@/types/contact.ts";
import { api } from "./http.ts";

/**
 * Permanently delete the current user's account and all associated data.
 */
export const deleteUserAccount = async (confirmation: string, reason?: string): Promise<void> => {
  await api.post("/api/a/users/me/delete", { confirmation, reason: reason?.trim() || undefined });
};

/**
 * Create or update a location in the user's Contact by type (upsert)
 * This will update the location with the matching type, or create a new one if none exists
 * Enforces one location per type
 */
export const updateUserLocation = async (location: CreateContactLocationReq): Promise<void> => {
  try {
    // Use generic endpoint with type in payload for upsert behavior
    await api.post("/api/a/users/me/location", location);
  } catch (error) {
    console.error("Error updating user location:", error);
    throw error;
  }
};

/**
 * Delete a location from the user's Contact by type
 */
export const deleteUserLocation = async (type: "home" | "work" | "other"): Promise<void> => {
  await api.post("/api/a/users/me/location/delete", { type });
};

/**
 * Update the user's timezone preference (home vs current)
 */
export const updateTimezonePreference = async (preference: "home" | "current"): Promise<void> => {
  try {
    await api.post("/api/a/users/me/preferences/location", { timezonePreference: preference });
  } catch (error) {
    console.error("Error updating timezone preference:", error);
    throw error;
  }
};

/**
 * Get the user's current timezone from the browser
 */
export const getCurrentTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Update the user's current location in the Contact
 */
export const updateUserCurrentLocation = async (location: string): Promise<void> => {
  try {
    await api.post("/api/a/users/me/location", { location });
  } catch (error) {
    console.error("Error updating user current location:", error);
    throw error;
  }
};
